module.exports = "/assets/8c225a25a61584b9af87925ae60cc205.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/CA.png
// module id = 1258
// module chunks = 0